import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke=\"#000\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" clip-path=\"url(#a)\"><path d=\"M12 2.637v5\" opacity=\".8\"></path><path d=\"M2.815 11.823h5M5.506 18.317l3.535-3.536\" opacity=\".4\"></path><path d=\"M5.506 5.328 9.04 8.864\" opacity=\".6\"></path><path d=\"M12 16.007v5\" opacity=\".3\"></path><path d=\"M16.185 11.823h5\" opacity=\".2\"></path><path d=\"m14.959 8.864 3.535-3.536\"></path><path d=\"m14.959 14.782 3.535 3.535\" opacity=\".3\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }